import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { useFeatureDisclaimers } from 'features/content/hooks/use-feature-disclaimers';

import Modal, { ModalContent, ModalSize } from 'components/modal';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import { ItemNutrition } from './item-nutrition';
import { NutritionModalDisclaimer } from './nutrition-modal-disclaimer';
import { INutritionProps } from './types';

const Nutrition: React.FC<React.PropsWithChildren<INutritionProps>> = ({
  nutritionFacts,
  onDismiss,
}) => {
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { calorie } = featureDisclaimers || {};

  const modalHeading = t('nutritionalInformationAndAllergen');
  return (
    <Modal
      size={ModalSize.FULLSCREEN}
      onDismiss={onDismiss}
      amplitudeEventData={{
        modalAppearanceEventMessage: 'Nutritional Information',
      }}
      testID="nutrition-modal"
      backgroundColor={getDesignToken('background-default')}
      header={modalHeading}
      headerTextIsBelowCloseButton
    >
      <ModalContent alignItems="center">
        <ScrollView showsVerticalScrollIndicator={false} focusable>
          {nutritionFacts
            .filter(
              elem =>
                elem.itemName?.toLowerCase() !== 'combo item' &&
                elem.itemName?.toLowerCase() !== 'mix n match'
            )
            .map(({ itemName, itemImage, facts, allergenGroups, ingredients }) => (
              <ItemNutrition
                key={itemName}
                itemImage={itemImage}
                itemName={itemName}
                nutritionInfo={facts}
                allergenGroups={allergenGroups}
                ingredients={ingredients}
              />
            ))}
          <NutritionModalDisclaimer content={calorie?.localeRaw} />
        </ScrollView>
      </ModalContent>
    </Modal>
  );
};

export default Nutrition;
